import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { addData, imgurl } from "../Servicescalls";

function Eventdetails() {
  const [forms, setForms] = useState([]);
  const [gallery, setgallery] = useState([]);

  const getSingleevent = async () => {
    const bodydata = {
      _id: sessionStorage.getItem("objid"),
    };
    const resonse = await addData("eventweb/getEvent", bodydata);
    var _data = resonse;
    setForms(_data.data.eventResult);
  };
  const GetAllDetails = async () => {
    const bodydata = {
      eventId: "All",
    };
    const resonse = await addData("home/getHomeItems", bodydata);
    var _data = resonse;
    setgallery(_data.data.socialgallery);
  };

  useEffect(() => {
    getSingleevent();
    GetAllDetails();
  }, []);

  return (
    <div>
      <Header />
      <div className="cat-main-wrapper">
        <section className="cat-page-title-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="cat-page-title">
                  <h1>Event Details</h1>
                  <ul>
                    <li>
                      <a href="#">Home</a>
                    </li>
                    <li>Event Details</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div>
          <section className="cat-about-wrapper cat-section-spacer">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <div className="cat-story-img">
                    <img
                      src={imgurl + forms.image}
                      alt=""
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                  <div className="cat-story-info">
                    <div className="cat-heading-wrapper">
                      <h2>{forms.name}</h2>
                    </div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          forms?.description &&
                          forms.description.trim().length > 0
                            ? forms.description.length > 680
                              ? forms.description.slice(0, 680) + "..."
                              : forms.description
                            : "No description available",
                      }}
                    ></div>

                    <a
                      type="button"
                      className="cat-btn header-btn mt-3"
                      data-toggle="modal"
                      data-target="#exampleModal"
                    >
                      Request
                    </a>
                    {/* <ul className="cat-story-list">
                    <li>
                      <span>
                        <svg enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><path d="m271.176 121.396c-150.205 7.822-271 132.495-271 284.604v106l37.925-88.29c44.854-89.692 133.847-147.041 233.075-152.314v121.318l240.648-196.714-240.648-196z" /></g></svg>
                      </span> Fresh and Fast food Delivery
                    </li>
                    <li>
                      <span>
                        <svg enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><path d="m271.176 121.396c-150.205 7.822-271 132.495-271 284.604v106l37.925-88.29c44.854-89.692 133.847-147.041 233.075-152.314v121.318l240.648-196.714-240.648-196z" /></g></svg>
                      </span> 24/7 Customer Support
                    </li>
                    <li>
                      <span>
                        <svg enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><path d="m271.176 121.396c-150.205 7.822-271 132.495-271 284.604v106l37.925-88.29c44.854-89.692 133.847-147.041 233.075-152.314v121.318l240.648-196.714-240.648-196z" /></g></svg>
                      </span> Easy Customization Options
                    </li>
                    <li>
                      <span>
                        <svg enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><path d="m271.176 121.396c-150.205 7.822-271 132.495-271 284.604v106l37.925-88.29c44.854-89.692 133.847-147.041 233.075-152.314v121.318l240.648-196.714-240.648-196z" /></g></svg>
                      </span> Delicious Deals for Delicious Meals
                    </li>
                  </ul> */}
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="cat-event-wrapper cat-section-spacer">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 ">
                  <div className="cat-heading-wrapper">
                    {/* <h4>
                    Latest Events
                  </h4> */}
                    <h2>Our Social & Business Events Gallery</h2>
                    <p
                      className="mb-3 mt-3"
                      dangerouslySetInnerHTML={{
                        __html:
                          forms?.moreinfo && forms.moreinfo.trim().length > 0
                            ? forms.moreinfo.length > 720
                              ? forms.moreinfo.slice(0, 720) + "..."
                              : forms.moreinfo
                            : "No information available",
                      }}
                    ></p>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div className="cat-filter" id="MixItUpB833A1">
                    <div className="row">
                      {gallery.map((data, key) => (
                        <div
                          key={key}
                          className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 mix wedding"
                          style={{ display: "inline-block" }}
                        >
                          <div className="cat-porfolio-section">
                            <img
                              style={{ minHeight: "140px", maxHeight: "140px" }}
                              src={imgurl + data.image}
                              alt=""
                            />
                            <div className="cat-overlay">
                              <a
                                className="popup-gallery"
                                href={imgurl + data.image}
                                title
                              >
                                <span
                                  className="fa fa-search-plus"
                                  aria-hidden="true"
                                />
                              </a>
                              <div className="cat-overlay-text">
                                <h4>{data.title}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Eventdetails;
